import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { DropdownList } from "react-widgets";
import { toastr } from "react-redux-toastr";
import { Customer } from "../../../core/api/models";
import ErrorMessage from "../../../components/text/ErrorMessage";
import title from "../../../utils/title.json";
import api from "../../../api";
import { ValidateAlphabets } from "../../../utils/Validatation";
import { AppPermissions, useHasPermission } from "../../../core";

interface FormProps {
  prefix?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
}

const SearchCustomer: React.FunctionComponent<{
  error?: string;
  onClose: () => void;
  updateUser: (details: Customer) => void;
  customerDetails?: Customer;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<FormProps>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const [saving, setSaving] = useState(false);

  const canUpdateCustomerName = useHasPermission(AppPermissions.UpdateCustomerName);

  const onSubmit = async (data?: any) => {
    setSaving(true);
    const updateData = {
      prefix: data.prefix,
      firstName: data.firstName,
      lastName: data.lastName,
      phones: props.customerDetails?.phones,
      emails: props.customerDetails?.emails,
      middleName: data.middleName,
    };
    try {
      const response = await api.customer.updateCustomer(updateData, props.customerDetails?._id);
      props.updateUser(response);
      props.onClose();
      setSaving(false);
      toastr.success("Success", "Contact details successfully");
    } catch (error) {
      setSaving(false);
      if (error?.response?.data?.data?.message) {
        toastr.error("Error", error?.response?.data?.data?.message);
      } else {
        toastr.error("Error", error?.response?.data?.message);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mt-2 d-flex flex-wrap px-4 py-2 border-top border-bottom contact-form-row active align-items-center">
        <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
          Title <span className="text-danger">*</span>
        </div>
        <div className="col pl-2 pr-0 contact-content align-items-center">
          <Controller
            control={control}
            rules={{ required: true }}
            name="prefix"
            defaultValue={props.customerDetails?.prefix}
            render={({ onChange, value }) => (
              <DropdownList
                value={value}
                defaultValue={value}
                data={title}
                textField={"name"}
                valueField={"name"}
                placeholder={"Select prefix"}
                onChange={(val) => {
                  onChange(val.name);
                }}
                disabled={
                  !!props.customerDetails?.identifiers?.magicNumber && !canUpdateCustomerName
                }
              />
            )}
          />
          {errors.prefix && <ErrorMessage>Prefix is required</ErrorMessage>}
        </div>
        <div className="w-100 mb-1"></div>
        <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
          First Name<span className="text-danger">*</span>
        </div>
        <div className="col pl-2 pr-0 contact-content align-items-center">
          <Controller
            control={control}
            rules={{
              required: !props.customerDetails?.identifiers?.magicNumber,
              // validate: (value) => {
              //   return !!value.trim();
              // },
              validate: (value) => {
                return value ? !!ValidateAlphabets(value) : true;
              },
              maxLength: 25,
            }}
            name="firstName"
            defaultValue={props.customerDetails?.firstName}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="font-sm font-weight-semibold form-control form-control-sm"
                placeholder="First Name"
                name={name}
                value={value}
                onChange={onChange}
                id="firstName"
                disabled={
                  !!props.customerDetails?.identifiers?.magicNumber && !canUpdateCustomerName
                }
              />
            )}
          />

          {errors.firstName && errors.firstName.type === "required" && (
            <ErrorMessage>First name is required</ErrorMessage>
          )}
          {errors.firstName && errors.firstName.type === "maxLength" && (
            <ErrorMessage>First name should contains maximum 25 characters</ErrorMessage>
          )}
          {errors.firstName && errors.firstName.type === "validate" && (
            <ErrorMessage>Invalid First Name</ErrorMessage>
          )}
        </div>

        <div className="w-100 mb-1"></div>
        {/* <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">Middle Name</div> */}
        {/* <div className="col pl-2 pr-0 contact-content align-items-center">
          <Controller
            control={control}
            rules={{
              required: false,
              validate: (value) => {
                return value ? !!ValidateAlphabets(value) : true;
              },
              maxLength: 25,
            }}
            name="middleName"
            defaultValue={props.customerDetails?.middleName}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="font-sm font-weight-semibold form-control form-control-sm"
                placeholder="Middle Name"
                name={name}
                value={value}
                onChange={onChange}
                id="middleName"
                disabled={
                  !!props.customerDetails?.identifiers?.magicNumber && !canUpdateCustomerName
                }
              />
            )}
          />

          {errors.middleName && errors.middleName.type === "required" && (
            <ErrorMessage>Middle name is required</ErrorMessage>
          )}
          {errors.middleName && errors.middleName.type === "maxLength" && (
            <ErrorMessage>Middle name should contains maximum 25 characters</ErrorMessage>
          )}
          {errors.middleName && errors.middleName.type === "validate" && (
            <ErrorMessage>Invalid Middle Name</ErrorMessage>
          )}
        </div> */}

        <div className="w-100 mb-1"></div>
        <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
          Last Name
           {/* <span className="text-danger">*</span> */}
        </div>
        <div className="col pl-2 pr-0 contact-content align-items-center">
          <Controller
            control={control}
            // rules={{
            //   required: true,
            //   validate: (value) => {
            //     return value ? !!ValidateAlphabets(value) : true;
            //   },
            //   maxLength: 25,
            // }}
            name="lastName"
            defaultValue={props.customerDetails?.lastName}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="font-sm font-weight-semibold form-control form-control-sm"
                placeholder="Last Name"
                name={name}
                value={value}
                onChange={onChange}
                id="lastName"
                disabled={
                  !!props.customerDetails?.identifiers?.magicNumber && !canUpdateCustomerName
                }
              />
            )}
          />
          {errors.lastName && errors.lastName.type === "required" && (
            <ErrorMessage>Last name is required</ErrorMessage>
          )}
          {errors.lastName && errors.lastName.type === "maxLength" && (
            <ErrorMessage>Last name should contains maximum 25 characters</ErrorMessage>
          )}
          {errors.lastName && errors.lastName.type === "validate" && (
            <ErrorMessage>Invalid Last Name</ErrorMessage>
          )}
        </div>
        <div className="col-12 pl-2 pr-0 mt-2 text-right">
          <button className="btn btn-sm btn-outline-dark mr-2 font-normal" onClick={props.onClose}>
            Cancel
          </button>
          <button disabled={saving} className="btn btn-sm btn-primary font-normal">
            Save
          </button>
        </div>
      </div>
    </form>
  );
};

export default SearchCustomer;
